module.exports = __webpack_public_path__ + "static/reborn-99ecd902b21a37d0caaf293100af762c.png";